import api, { apiLink } from './../api'
import axios from 'axios/index'

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    send(store, params) {
      return new Promise((resolve, reject) => {
        api.post(`service/send-${params.serviceType}`, params).then(response => {
          if (response.data.error) {
            store.dispatch('alert/error', response.data.status, { root: true })
            reject(response.data)
          } else {
            store.dispatch('alert/success', response.data.status, { root: true })
            resolve(response.data)
          }
        }).catch(error => {
          store.dispatch('alert/error', error.response.data.status, { root: true })
          reject(error.response.data)
        })
      })
    },
    appInfo() {
      return axios.get(apiLink() + 'service/app-info');
    },
  },
  mutations: {},
}



// WEBPACK FOOTER //
// ./src/store/modules/service.js